var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { forwardRef, } from 'react';
import { TransferAccountSelect as TransferSelect, } from '@ally/aos-shared-account-select';
import { utils } from '@ally/forms';
import { useField } from 'formik';
export var defaultValidate = function (value) {
    if (!value) {
        return 'Select an account.';
    }
    return undefined;
};
var AccountSelectWithForms = function (BaseComponent) {
    return forwardRef(function (props, propRef) {
        var name = props.name, onChange = props.onChange, onBlur = props.onBlur, useDefaultValidate = props.useDefaultValidate, validate = props.validate;
        var selectedValidation = validate || (useDefaultValidate ? defaultValidate : undefined);
        var _a = __read(useField({
            name: name,
            validate: selectedValidation,
        }), 3), field = _a[0], meta = _a[1], helpers = _a[2];
        var refValue = utils.useRegisterError(meta.error).refValue;
        var ref = propRef && refValue ? utils.mergeRefs([propRef, refValue]) : refValue;
        var combinedOnChange = function (value, event) {
            helpers.setValue(value);
            if (onChange)
                onChange(value, event);
        };
        var combinedOnBlur = function (e) {
            field.onBlur(e);
            if (onBlur)
                onBlur(e);
        };
        var errorMessage = meta.touched ? meta.error : '';
        var baseComponentProps = __assign(__assign(__assign({ id: name, ref: ref, error: errorMessage }, field), props), { onChange: combinedOnChange, onBlur: combinedOnBlur });
        return React.createElement(BaseComponent, __assign({}, baseComponentProps));
    });
};
var TransferAccountSelect = AccountSelectWithForms(TransferSelect);
export default TransferAccountSelect;
//# sourceMappingURL=TransferAccountSelect.js.map